import dayjs from 'dayjs';
import dayLabel from 'utils/datetime/format/dayLabel';

const dateAndTime = ({ date }: { date: Date | string }) => {
	const day = dayjs(date);
	const _date = dayLabel.getByDate(day.toDate());
	const _time = day.format('HH:mm');

	return `${_date}, ${_time}`;
};

export default dateAndTime;
